import { ComponentProps, ContextType } from 'react';
import ModuleContext from '../_contexts/ModuleContext';

import Avatar from '@pelckmans/elementis/components/avatar';
import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Pill from '@pelckmans/elementis/components/pill';

interface Props {
  module: NonNullable<ContextType<typeof ModuleContext>['selectedModule']>;
  size?: ComponentProps<typeof Pill>['size'];
}

export default function ModuleHeaderTag({ module, size }: Props) {
  return (
    <Pill
      key="module-pill"
      size={size}
      avatar={
        <Avatar>
          <AvatarImage size="xs" name={module.niceName} src={module.styling?.logo || ''} />
        </Avatar>
      }
    >
      {module.niceName}
    </Pill>
  );
}
